import ListMerchantsPage from './ListMerchantsPage';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetAgencyByIdQuery } from '../../agencies/agency.api-slice';
import { useParams } from 'react-router-dom';

interface IProps {
  pendingOnly?: boolean;
}

const ListMerchantsForAgencyPage: React.FC<IProps> = ({ pendingOnly }) => {
  const { id } = useParams();
  const { data, isLoading } = useGetAgencyByIdQuery(id ?? skipToken);

  if (isLoading || id == null) {
    return <LoadingSpinner />;
  }

  return <ListMerchantsPage scope="agency" agency={data} />;
};

export default ListMerchantsForAgencyPage;
